export default {
  CLEAR_CART: 'CLEAR_CART',

  // Subscription
  CREATED_SUBSCRIPTION   : 'CREATED_SUBSCRIPTION',
  DELETED_SUBSCRIPTION   : 'DELETED_SUBSCRIPTION',
  RECEIVED_SUBSCRIPTIONS : 'RECEIVED_SUBSCRIPTIONS',

  // Pet
  UPDATED_PET : 'UPDATED_PET',

  // Error
  ERR: 'ERROR_OCCUR',
  CLEAR_ERR: 'CLEAR_ERR',
}
